import React from 'react';
import '../index.css';


function PrivacyPolicy() {
  return (
    <div className='privacyPolicy'>
          <div className="privacyPolicyCard">

      <div>
    <h1>Privacy Policy</h1>

<p>This <span className='privacy'>privacy policy</span> outlines the types of personal information that we, <span className='getDoJo'>"getDOJO"</span>, may collect from users of our website and how we may use, disclose, and protect that information.</p>

<h2>Information We Collect</h2>

<p>We may collect various types of personal information from Users who visit our Website, including, but not limited to:</p>

<ul className="listOfPolicies">
<li>- Personal identification information such as your name, email address, and contact details that you voluntarily provide to us when you submit a form, register an account, or contact us through the Website.</li>
<li>- Automatically collected information such as log files, usage data, cookies, and other tracking technologies that may be used to enhance your experience on our Website, analyze trends, and gather demographic information.</li>
</ul>



<h2>Use of Information</h2>

<p >We may use the personal information we collect from Users for the following purposes:</p>

 <ul className="listOfPolicies">
    <li>- To provide and improve our services: We may use your personal information to fulfill your requests, communicate with you, and improve the functionality and performance of our Website.</li>
    <li>- To personalize user experience: We may use your information to understand how you use our Website and provide you with tailored content and offerings.</li>
    <li>- To send periodic emails: We may use your email address to send you information, updates, and promotions related to our services or respond to inquiries and other requests.</li>
    <li>- To comply with legal obligations: We may use and disclose your personal information to comply with applicable laws, regulations, or legal processes, and protect our legal rights.</li>
  </ul>


<h2>Disclosure of Information</h2>

<p>We may disclose your personal information to third parties in the following circumstances:</p>


<ul className="listOfPolicies">
<li>- Service providers: We may share your personal information with trusted third-party service providers who assist us in operating our Website, conducting our business, and providing services to you.</li>
<li>- Legal requirements: We may disclose your personal information to comply with applicable laws, regulations, or legal processes, and respond to lawful requests from public authorities.</li>
<li>- Business transfers: If we are involved in a merger, acquisition, or sale of all or a portion of our assets, your personal information may be transferred as part of that transaction.</li>
</ul>

<h2>Security</h2>

<p>We take reasonable measures to protect the security of your personal information and prevent unauthorized access, use, or disclosure. However, please note that no method of transmission over the internet or method of electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

<h2>Third-Party Websites</h2>

<p>Our Website may contain links to third-party websites or resources that are not operated or controlled by us. This Privacy Policy does not apply to those third-party websites, and we are not responsible for the privacy practices or content of those websites. We encourage you to review the privacy policies of those third-party websites before providing any personal information.</p>

</div>
    </div>
    <p className='codedBy'>Coded by Diana (Dee) Kalstein  <img src="https://res.cloudinary.com/djzhnyobz/image/upload/v1683750470/dianacartoon_fsy44z.png" alt="diana-face" width="50"/></p>

    </div>

  );
};

export default PrivacyPolicy;
